import styled, { keyframes } from 'styled-components/macro';
import { LoaderCircle } from 'lucide-react';

const spinAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = styled(function Spinner({ className }) {
    return <span className={className}><LoaderCircle size={20} /></span>;
})`
  display: inline-block;
  svg {
    animation: ${spinAnimation} 1s linear infinite;
  }
`;

export default Spinner;
